import { SiRedux, SiTypescript, SiWebassembly } from 'react-icons/si';
import Title from '../layout/Title';
import Card from './Card';
import { FaChartLine, FaGlobe, FaMobile, FaPaintBrush, FaPenNib, FaVideo } from 'react-icons/fa';

const Features = () => {
  return (
    <section
      id='features'
      className='w-full px-5 py-20  border-b-[1px] border-b-black '
    >
      <Title className='text-center lgl:text-[20px]' title='Feature' des='What I Do' />
      <div className='grid grid-cols-1 gap-10 md:grid-cols-2 xl:grid-cols-3 xl:gap-20'>
        <Card
          title='Web Development'
          des='A functional, scalable and responsive fullstack web development with API integrations using professional tools like React, Tailwindcss, Nodejs or Flask, MongoDB, AWS Services, etc.'
          icon={<SiWebassembly />}
        />
        <Card
          title='Mobile App Dev.'
          des='Build highly efficient mobile applications with excellent build tools like Android Studio using Java or Kotlin programming languages in dark and light modes'
          icon={<FaMobile />}
        />
        <Card
          title='Video Editor'
          des='Clean, detail-oriented and stylish video production with top-notch resolutions and high quality. Experienced in Adobe Premiere Pro, Lightwork, Capcut, Inshot, Canva, etc. to ensure optimum satisfaction.'
          icon={<FaVideo />}
        />
        <Card
          title='Graphic Designer'
          des='Creative graphic designer skilled in crafting visual concepts, branding, and digital assets. Experienced in Adobe Creative Suite, Canva, Figma, and modern design tools to deliver engaging and impactful visuals.'
          icon={<FaPaintBrush />}
        />
        <Card
          title='SEO Optimization'
          des='SEO specialist improving search rankings, boosting traffic, and enhancing visibility through keyword research, on-page optimization, and data-driven strategies.'
          icon={<FaGlobe />}
        />
        <Card
          title='Data Analysis'
          des='Data analyst turning raw data into actionable insights with Python, SQL, PowerBi and Excel. Skilled in visualization, reporting, and supporting data-driven decisions.'
          icon={<FaChartLine />}
        />
      </div>
    </section>
  );
};
export default Features;
